<script>
    import { Bar } from 'vue-chartjs';

    export default {
        extends: Bar,
        props: {
            chartLabel: {
                type: Array
            },
            chartData: {
                type: Array
            },
            chartOptions: {
                type: Object
            }
        },
        methods: {

        },
        mounted() {
            this.renderChart({
                labels: this.chartLabel,
                datasets: this.chartData
            }, this.chartOptions);
        }
    };
</script>


// WEBPACK FOOTER //
// resources/assets/admin/js/components/charts/BarChart.vue